export const config = Object.freeze({
  appName: 'ZenSkills', allowedEmailDomain: 'zencomms.com', superAdminEmail: 'shareef@zencomms.com', databaseId: 'zentrain',
  firebase: { apiKey: 'AIzaSyDB4jBNF0axVMKdekwW4Af88FDaVZK3-aM', authDomain: 'zenapps-8cda2.firebaseapp.com', projectId: 'zenapps-8cda2', storageBucket: 'zenapps-8cda2.firebasestorage.app', messagingSenderId: '715909919925', appId: '1:715909919925:web:e2e247cb7b1f184c57bafc', measurementId: 'G-XSMBL7V075' }
});
